import { render } from 'preact';
import tryParseJSON from '../utils.common/tryParseJson';
import { App } from './App';

/**
 * The ecard creator page is a preact app that gathers all of the relevant information client side, and then sends it off to an API point that handles the actual creation and ecard sending functionality
 */

const ecardCreateComponent = document.querySelector('.ecard-creator-component');

if (ecardCreateComponent) {
    const ecardData = tryParseJSON(ecardCreateComponent.getAttribute('ecard-data'));
    render(<App {...ecardData} />, ecardCreateComponent);
}
